'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { LOCALE_COOKIE, localizePath, splitLocale, type Locale } from '#/i18n/config';

/**
 * 언어 전환 단추(#315). 같은 화면의 다른 언어 주소로 보낸다.
 * 선택은 쿠키에 기억만 하고, 접속 때 자동으로 옮기지는 않는다(검색 로봇이 엉뚱한 언어로 쫓겨나지 않게).
 */
export function LanguageSwitcher({
  locale,
  labels
}: {
  locale: Locale;
  labels: { ko: string; en: string; switchTo: string };
}) {
  const pathname = usePathname() ?? '/';
  const search = useSearchParams()?.toString();
  const target: Locale = locale === 'ko' ? 'en' : 'ko';
  const { rest } = splitLocale(pathname);
  const href = localizePath(rest, target) + (search ? `?${search}` : '');

  return (
    // next/link 는 클라이언트 이동이라 이미 그려진 루트 레이아웃(요청 언어 헤더로 정해짐)을 재사용해
    // 주소만 바뀌고 글이 안 바뀐다(새로고침해야 바뀜). 언어 전환은 전체 이동이어야 하므로 <a> 를 쓴다.
    <a
      href={href}
      hrefLang={target}
      lang={target}
      aria-label={labels.switchTo}
      title={labels.switchTo}
      className="rounded-md px-2 py-1 text-sm font-medium hover:bg-accent"
      onClick={() => {
        document.cookie = `${LOCALE_COOKIE}=${target}; path=/; max-age=31536000; samesite=lax`;
      }}
    >
      {labels[target]}
    </a>
  );
}
